import { render } from "./autoReply.vue?vue&type=template&id=6ec6d598"
import script from "./autoReply.vue?vue&type=script&lang=js"
export * from "./autoReply.vue?vue&type=script&lang=js"

import "./autoReply.vue?vue&type=style&index=0&id=6ec6d598&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_im/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__